import { Loader } from '@googlemaps/js-api-loader';

import { GOOGLE_API_KEY } from '../../config';

/**
 * Load the google maps API.
 * @see https://www.npmjs.com/package/google-maps-api-loader
 * @yields API
 */
export default async function loadMapsApi() {
  if (window.google) {
    return window.google;
  }

  // using same options as the angular maps ui loader
  const loader = new Loader({
    apiKey: GOOGLE_API_KEY,
    transport: 'https',
    isGoogleMapsForWork: false,
    china: false,
    v: '3',
    language: 'en',
    preventLoad: false,
    libraries: ['geometry', 'places'],
    version: 'weekly',
  });

  return loader.load().then(() => window.google);
}
